module.exports = __webpack_public_path__ + "63141c2e2c14a8c9cca4f80264b8effb.jpg";